import React from 'react'
import { Link } from 'react-router-dom';
function Herosection1() {
  const gototop=()=>{
    window.scrollTo({top:0,behavior:"smooth"})
}
  return (
    <>
      <section className="hero-banner position-relative custom-py-1 hero-shape1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-5 col-xl-6 order-lg-1 mb-8 mb-lg-0">
              {/* <!-- Image --> */}
              <img
                src={require("../../assets/images/inspectiver/01.webp")}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="col-12 col-lg-7 col-xl-6">
              <h2 className="mb-5">We're here to improve your car buying experience!</h2>
              {/* <!-- Buttons --> */}
              {/* <div  className="btn btn-primary" onClick={gototop}> Order Your Inspection </div> */}

              <Link className="btn btn-dark " to="quotation">Order Your Inspection</Link>
              <blockquote className="mt-5 mb-0 ps-3 border-start border-primary">
                {/* <!-- Text --> */}
                <p className="lead mb-2 font-w-6">
                  Found your dream car?
                
                </p>
                <p className="lead mb-2">Share the details with us, and let us help you verify your vehicle with a thorough, on-site inspection conducted by experts.</p>
                <p className="lead mb-0">
                Starting at just <mark><strong><b>$139.00</b></strong></mark>
                </p>
              </blockquote>
            </div>
          </div>
          {/* <!-- / .row --> */}
        </div>
        {/* <!-- / .container --> */}
      </section>
    </>
  )
}

export default Herosection1
